import styles from "@styles/Wallet.module.scss";
import videoSrc from "@assets/video-wallet.mp4";
import LogoFull from "@assets/eventsquare-full.svg?react";
import flag from "@assets/flag.png";
import { ButtonGroup } from "@eventsquare/uikit";

const Wallet = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.background}>
          <video
            className={styles.backgroundVideo}
            autoPlay
            loop
            muted
            playsInline
          >
            <source src={videoSrc} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className={styles.gradientOverlay}></div>
          <div className={styles.content}>
            <div className={styles.header}>
              <div className={styles.logo}>
                <LogoFull />
              </div>
              <div className={styles.region}>
                <img src={flag} alt="nl" />
              </div>
            </div>
            <div className={styles.body}>
              <h1 className={styles.body__title}>
                Unforgettable moments start here.
              </h1>
              <p className={styles.body__description}>
                Your all-in-one app for event tickets, real-time updates, and
                seamless cashless payments!
              </p>
            </div>
            <div className={styles.footer}>
              <ButtonGroup noMargin>
                <button
                  className={styles.loginButton}
                  onClick={() => {
                    window.location.href = "/login";
                  }}
                >
                  Login
                </button>
                <button
                  className={styles.registerButton}
                  onClick={() => {
                    window.location.href = "/register";
                  }}
                >
                  Sign Up
                </button>
              </ButtonGroup>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Wallet;
